import { Button } from '../../../components/common/Button/Button';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { DASHBOARD } from '../../../routes/routes';

import { Icon, IconApproveNFTFail } from '../../../styles/Icons';

import { P1, P2 } from '../../../styles/FontStyles';
import { Link } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { flipMeGetInfo } from '../../FlipMeWallet/FlipMeWallet.actions';
import { useAppDispatch } from '../../../app/hooks';

interface Step4Props {
  packageId: number | null | undefined;
  setRedeemCardsModal: Dispatch<SetStateAction<boolean>>;
}

export const Step4 = ({ packageId, setRedeemCardsModal }: Step4Props) => {
  const dispatch = useAppDispatch();
  return (
    <Box>
      <Flexed column center>
        <Icon>
          <IconApproveNFTFail />
        </Icon>

        <P2 bold mt='30' mb='30' center>
          To proceed you need to complete KYC verification in the FlipMe app.
          Please complete the verification and retry.
        </P2>
      </Flexed>
      {packageId ? (
        <Flexed column center>
          <Link to={DASHBOARD}>
            <Button w='200px' negative onClick={() => {}}>
              Back to Dashboard
            </Button>
          </Link>
        </Flexed>
      ) : (
        <Flexed column center>
          <Button
            w='200px'
            negative
            onClick={() => {
              dispatch(flipMeGetInfo());

              setRedeemCardsModal(false);
            }}>
            Back to Dashboard
          </Button>
        </Flexed>
      )}
    </Box>
  );
};
